export const InsuranceDetailSource = {
  favorite: 'favorite',
} as const

export type InsuranceDetailSource =
  (typeof InsuranceDetailSource)[keyof typeof InsuranceDetailSource]
